import APIServiceLookUp from './serviceAPI';
import { API_URL } from './models/AppConstent';

export default class ServiceHighlight {
    lookupService = new APIServiceLookUp();

    async getAllHighlight(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}highlight/getAllHighlight`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async setHighlight(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}highlight/setHighlight`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async updateHighlight(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}highlight/updateHighlight`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async delHighlight(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}highlight/delHighlight`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

}
